import {CheckFormInfo} from "@/pages/checks/components/form/CheckFormInfo.tsx";
import {CheckLinkedSchedules} from "@/pages/checks/update/sections/maintenance/CheckLinkedSchedules.tsx";
import {CheckManualMaintenanceForm} from "@/pages/checks/update/sections/maintenance/CheckManualMaintenanceForm.tsx";

export const CheckMaintenanceFormV2 = () => {
  return (
    <div className={"d-flex flex-column gap-4"}>
      <div className={"d-flex flex-column gap-2"}>
        <div className="pulseTextBodyBold">Maintenance Rules</div>
        <CheckFormInfo
          title="During maintenance any failed Checks will be ignored in uptime calculations and Alerts will not be sent."
          typographySize={"small"}
        />
      </div>
      <CheckManualMaintenanceForm />
      <CheckLinkedSchedules />
    </div>
  );
};
